import { useParams } from "react-router-dom";
import { progressTypes } from "utils/CommonConstants";
import ProgressInfo from "./ProgressInfo";

const Progress = () => {
  const params = useParams();

  return (
    <div>
      <ProgressInfo progressType={params?.type || progressTypes.plan} />
    </div>
  );
};
export default Progress;
